/* src/components/classification/classification.component.scss */
:host {
  display: block;
}
.classification {
  --classification-color: var(--vwui-color-neutral-2);
  display: block;
  float: left;
  white-space: nowrap;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 0.4rem;
  line-height: 1;
  color: var(--classification-color);
  border: 1px solid var(--classification-color);
  border-radius: 0.15rem;
  box-sizing: content-box;
  overflow: hidden;
  opacity: 0.75;
}
.classification__label,
.classification__value {
  display: block;
  float: left;
  padding: 0.3rem;
}
.classification__value {
  background: var(--classification-color);
  color: #fff;
}
.classification::after {
  content: "";
  display: table;
  width: 100%;
  clear: both;
}
/*# sourceMappingURL=classification.component-SAXPUPE7.css.map */
